module.exports = __webpack_public_path__ + "img/googlemaps.d87c6385.svg";